import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuCmmsStatusLabelComponent } from './au-cmms-status-label.component';
import { NgxTolgeeModule } from '@tolgee/ngx';

@NgModule({
	imports: [CommonModule, NgxTolgeeModule, AuCmmsStatusLabelComponent],
	exports: [AuCmmsStatusLabelComponent],
})
export class AuCmmsStatusLabelModule {}
